import { PARKING_SESSIONS_TAB } from 'myParkdUtils/enums';
import { FormattedMessage } from 'react-intl';
import { SessionExportField } from 'screens/modals/sessionExport/ExportParkingHistoryModal';
import { SessionProperty } from 'types';


type Props = {
    checkedFields: SessionExportField[];
    setCheckedFields: Function;
    sessionsType: PARKING_SESSIONS_TAB
}

export const sessionsExportFieldsOnstreet: SessionExportField[] = [
    { value: 'licensePlate', label: 'PARKING_HISTORY_MODAL_LICENSE_PLATE' },
    { value: 'countryCode', label: 'PARKING_HISTORY_MODAL_COUNTRY_CODE' },
    { value: 'location', label: 'PARKING_HISTORY_MODAL_LOCATION' },
    { value: 'posCode', label: 'PARKING_HISTORY_MODAL_ZONE_CODE' },
    { value: 'startTime', label: 'PARKING_HISTORY_MODAL_START_TIME' },
    { value: 'endTime', label: 'PARKING_HISTORY_MODAL_END_TIME' },
    { value: 'duration', label: 'PARKING_HISTORY_MODAL_DURATION' },
    { value: 'userCost', label: 'PARKING_HISTORY_MODAL_COST' },
    { value: 'username', label: 'PARKING_HISTORY_MODAL_USERNAME' },
    { value: 'email', label: 'PARKING_HISTORY_MODAL_EMAIL' },
    { value: 'mode', label: 'PARKING_HISTORY_MODAL_PARKING_MODE' },
    { value: 'note', label: 'PARKING_HISTORY_MODAL_PARKING_NOTE' },
    { value: 'costCenter', label: 'PARKING_HISTORY_MODAL_COST_CENTER' }
];

export const sessionsExportFieldsOffstreet: SessionExportField[] = [
    { value: 'licensePlate', label: 'PARKING_HISTORY_MODAL_LICENSE_PLATE' },
    { value: 'countryCode', label: 'PARKING_HISTORY_MODAL_COUNTRY_CODE' },
    { value: 'location', label: 'PARKING_HISTORY_MODAL_LOCATION' },
    { value: 'endTime', label: 'PARKING_HISTORY_MODAL_TRANSACTION_DATE_TIME' },
    { value: 'userCost', label: 'PARKING_HISTORY_MODAL_COST' },
    { value: 'username', label: 'PARKING_HISTORY_MODAL_USERNAME' },
    { value: 'email', label: 'PARKING_HISTORY_MODAL_EMAIL' },
    { value: 'costCenter', label: 'PARKING_HISTORY_MODAL_COST_CENTER' }
]

export const getAllSessionFields = (sessionsType: PARKING_SESSIONS_TAB): SessionExportField[] =>
    sessionsType === PARKING_SESSIONS_TAB.TAB_HISTORICAL
        ? sessionsExportFieldsOnstreet
        : sessionsExportFieldsOffstreet;


const CheckedExportFields = (props: Props) => {

    const onChangeField = (event: React.ChangeEvent<HTMLInputElement>, value: SessionProperty, label: string) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            props.setCheckedFields([...props.checkedFields, { value, label }]);
            return;
        }

        const remainingFields = props.checkedFields.filter((field) => field.value !== value);
        props.setCheckedFields(remainingFields);
    }

    const allSessionsExportFields = getAllSessionFields(props.sessionsType);

    const getCheckboxValue = (checkedFields: SessionExportField[], value: string) => {
        return checkedFields.some(field => field.value === value);
    }

    return (
        <div className="export-modal-section">
            <div>
                <label>
                    <FormattedMessage id="PARKING_HISTORY_MODAL_EXPORT_FIELDS" />
                </label>
            </div>
            <div className="grid-col-3">
                {allSessionsExportFields?.map(({ value, label }: any, index: number) => (
                    <div className="grid-item" key={index}>
                        <input
                            id={`checkbox-${value}`}
                            type="checkbox"
                            checked={getCheckboxValue(props.checkedFields, value)}
                            disabled={value === 'licensePlate'}
                            onChange={(event) => onChangeField(event, value, label)}
                        />
                        <label htmlFor={`checkbox-${value}`}>
                            <FormattedMessage id={label} />
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CheckedExportFields;